import http from '@/utils/request';

export interface CurrentUser {
  userId: string;
  displayName: string;
  avatar: string;
}

/**
 * 静默探测当前太湖登录用户：
 * - 用于登录入口冷启动判断身份、AdminGuard 进入后台前的鉴权
 * - 失败不弹 toast，由调用方自行处理
 */
export const probeCurrentUser = () =>
  http.get<unknown, CurrentUser>('/user/me', { silent: true });
